import { render, staticRenderFns } from "./editOwnerVotingList.vue?vue&type=template&id=057a17da&scoped=true"
import script from "./editOwnerVotingList.vue?vue&type=script&lang=js"
export * from "./editOwnerVotingList.vue?vue&type=script&lang=js"
import style0 from "./editOwnerVotingList.vue?vue&type=style&index=0&id=057a17da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057a17da",
  null
  
)

export default component.exports